import { create } from 'zustand';

import { useAppStore } from '@/core/stores/appStore';
import {
    DEFAULT_BEDROOM_FILTER,
    type BedroomFilterOption,
} from '@/modules/properties-web/utils/unitListingFilters';

/**
 * Session-only bedroom filter for the unit listing.
 * Survives listing ↔ unit details navigation; resets on full page reload
 * and on logout, so the next user starts from the default selection.
 */
interface UnitListingFilterState {
    appliedBedrooms: readonly BedroomFilterOption[];
    setAppliedBedrooms: (bedrooms: readonly BedroomFilterOption[]) => void;
}

export const useUnitListingFilterStore = create<UnitListingFilterState>((set) => ({
    appliedBedrooms: DEFAULT_BEDROOM_FILTER,
    setAppliedBedrooms: (bedrooms) => set({ appliedBedrooms: bedrooms }),
}));

// Logout (clearAuth) does not reload the page or app, so reset here when the
// session ends instead of letting the previous user's selection carry over.
useAppStore.subscribe((state, previousState) => {
    if (previousState.auth.isAuthenticated && !state.auth.isAuthenticated) {
        useUnitListingFilterStore.setState({ appliedBedrooms: DEFAULT_BEDROOM_FILTER });
    }
});
